import Vue from 'vue'
import Router from 'vue-router'
import Template from 'wino-template'
import AuthService from 'wicomp-auth'
import TestService from '@/components/test'
import AnalyticsService from 'wicomp-analytics'

Vue.use(Router)
let routes = [
  {
    path: '/user',
    component: () => import('@/components/layout/layout.vue'),
    name: 'User',
    children: [
      ...AuthService.sub_routes,
      ...AnalyticsService.sub_routes,
    ]
  }
]

// Import Registered Services
importServices([
  Template,
  AuthService,
  AnalyticsService,
  TestService
])

// Initialize Router
let router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  window.scroll({ top: 0, behavior: 'smooth' });
  // Event.$emit('loader:show', true)
  next()
})

async function importServices(services) {
  for (let i = 0; i < services.length; i++) {
    let service = services[i]
    routes = routes.concat(service.routes)
  }
}

export default router